/** Mock dashboard screen — pixel-perfect match of the real Dashboard page at 1920x1080. */

export function DashboardScreen() {
  return (
    <div style={shell}>
      {/* Topbar — matches .topbar */}
      <div style={topbar}>
        <span style={brand}>RALEY</span>
        <nav style={{ display: "flex", gap: 16 }}>
          {["Competitions", "Riders", "Training", "Support"].map((t) => (
            <span key={t} style={navLink}>{t}</span>
          ))}
        </nav>
        <span style={{ fontFamily: F.mono, fontSize: 11, color: C.textMuted, marginLeft: "auto" }}>demo@koda-software.com</span>
      </div>

      {/* Content */}
      <div style={{ padding: 24 }}>
        {/* Page header — matches .page-header */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: `1px solid ${C.border}`, paddingBottom: 16, marginBottom: 24 }}>
          <div>
            <div style={{ fontSize: 20, fontWeight: 800, textTransform: "uppercase" as const, letterSpacing: 1, color: C.text }}>Competitions</div>
            <div style={{ fontSize: 13, color: C.textMuted, marginTop: 4 }}>Competitions and events you manage or judge</div>
          </div>
          <div style={btnPrimary}>New Competition</div>
        </div>

        {/* My Competitions */}
        <div style={{ fontSize: 10, fontWeight: 600, textTransform: "uppercase" as const, letterSpacing: "0.05em", color: C.textMuted, marginBottom: 10 }}>My Competitions</div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 16, marginBottom: 28 }}>
          {[
            { name: "Boardstock Invitational 2026", model: "Average", judges: 5, roles: ["Owner", "Producer"] },
            { name: "Red Bull Wake Open", model: "Olympic", judges: 7, roles: ["Owner"] },
            { name: "Summer Nationals", model: "Max", judges: 3, roles: ["Owner", "Judge"] },
          ].map((p) => (
            <div key={p.name} style={card}>
              <div style={{ fontSize: 13, fontWeight: 700, textTransform: "uppercase" as const, letterSpacing: 0.5, color: C.text }}>{p.name}</div>
              <div style={{ display: "flex", gap: 6, marginTop: 10, flexWrap: "wrap" as const }}>
                <span style={badgeRole}>{p.model}</span>
                <span style={{ ...badgeRole, background: C.surface3, color: C.textMuted }}>{p.judges} judges</span>
              </div>
              <div style={{ display: "flex", gap: 4, marginTop: 10 }}>
                {p.roles.map((r) => (
                  <span key={r} style={{
                    fontSize: 9, fontWeight: 600, textTransform: "uppercase" as const, letterSpacing: 0.5,
                    padding: "1px 6px",
                    background: r === "Owner" ? "rgba(59,130,246,0.15)" : r === "Judge" ? "rgba(234,179,8,0.15)" : "rgba(34,197,94,0.15)",
                    color: r === "Owner" ? C.accent : r === "Judge" ? C.warning : C.success,
                    border: `1px solid ${r === "Owner" ? "rgba(59,130,246,0.3)" : r === "Judge" ? "rgba(234,179,8,0.3)" : "rgba(34,197,94,0.3)"}`,
                  }}>{r}</span>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Invited Competitions */}
        <div style={{ fontSize: 10, fontWeight: 600, textTransform: "uppercase" as const, letterSpacing: "0.05em", color: C.textMuted, marginBottom: 10 }}>Invited Competitions</div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 16 }}>
          <div style={card}>
            <div style={{ fontSize: 13, fontWeight: 700, textTransform: "uppercase" as const, letterSpacing: 0.5, color: C.text }}>Moomba Masters</div>
            <div style={{ display: "flex", gap: 6, marginTop: 10 }}>
              <span style={badgeRole}>Weighted</span>
              <span style={{ ...badgeRole, background: C.surface3, color: C.textMuted }}>5 judges</span>
            </div>
            <div style={{ display: "flex", gap: 4, marginTop: 10 }}>
              <span style={{ fontSize: 9, fontWeight: 600, textTransform: "uppercase" as const, letterSpacing: 0.5, padding: "1px 6px", background: "rgba(234,179,8,0.15)", color: C.warning, border: "1px solid rgba(234,179,8,0.3)" }}>Judge</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const C = {
  bg: "#0a0a0b", surface: "#111113", surface2: "#1a1a1e", surface3: "#222228",
  border: "#2a2a32", text: "#e4e4e7", textMuted: "#71717a",
  accent: "#3b82f6", success: "#22c55e", warning: "#eab308",
};
const F = { sans: "'Inter', sans-serif", mono: "'JetBrains Mono', monospace" };

const shell: React.CSSProperties = { width: "100%", height: "100%", background: C.bg, fontFamily: F.sans, color: C.text, display: "flex", flexDirection: "column" };
const topbar: React.CSSProperties = { height: 48, background: C.surface, borderBottom: `1px solid ${C.border}`, display: "flex", alignItems: "center", gap: 24, padding: "0 24px", flexShrink: 0 };
const brand: React.CSSProperties = { fontFamily: F.mono, fontWeight: 800, fontSize: 15, letterSpacing: 2 };
const navLink: React.CSSProperties = { fontSize: 12, fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.5, color: C.textMuted };
const card: React.CSSProperties = { background: C.surface, border: `1px solid ${C.border}`, padding: 20 };
const badgeRole: React.CSSProperties = { display: "inline-flex", padding: "2px 8px", fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.5, background: C.surface3, color: C.accent, border: `1px solid ${C.border}`, fontFamily: F.mono };
const btnPrimary: React.CSSProperties = { padding: "8px 16px", background: C.accent, color: "#fff", fontSize: 13, fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.5 };
